import React from 'react';

export default function Badge({
  children,
  variant = 'primary', // 'primary' | 'accent' | 'success' | 'warning' | 'muted'
  className = '',
  ...props
}) {
  const baseStyles = "inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-bold uppercase tracking-wider";

  const variantStyles = {
    primary: "bg-acem-surface-container-low text-acem-primary border border-acem-border",
    accent: "bg-amber-100 text-amber-800 border border-amber-200",
    success: "bg-emerald-100 text-emerald-800 border border-emerald-200",
    warning: "bg-amber-50 text-amber-900 border border-amber-300",
    muted: "bg-gray-100 text-gray-700 border border-gray-200",
    acemPill: "bg-acem-primary text-white",
  };

  return (
    <span className={`${baseStyles} ${variantStyles[variant] || variantStyles.primary} ${className}`} {...props}>
      {children}
    </span>
  );
}
